import { Wording } from '@/types';

export const COOKING_WORDING_NO: Wording = {
  components_header_media_content: 'Matlagingsvideoer',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Oppskrifter',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmer',
  hero_text: 'Kok med lidenskap, spis med glede',
  hero_button_text: 'Begynn å lage mat i dag',
  components_ressources_section_title: 'RESSURSER',
  components_ressources_subheader_text: 'Alle ressursene du trenger for å lære, lage mat og skape bedre mat',
  components_ressources_span_text: 'Oppdag en rik samling av videooppskrifter, detaljerte matlagingsguider og ekspertinnsikt i smakskombinasjoner, matpresentasjon og kulinarisk kreativitet.',
  components_ressources_card_1_title: 'Matlagingsinspirasjon',
  components_ressources_card_1_text: 'Bli inspirert av kreative oppskrifter og matlagingsvideoer.',
  components_ressources_card_2_title: 'Matlagingskunnskap',
  components_ressources_card_2_text: 'Lær viktige matlagingsteknikker, smakskombinasjoner og det grunnleggende om matparing gjennom klare og praktiske guider.',
  components_ressources_link: 'Se videoer',
  components_notes_and_google_title_1: 'Matlagingsopplæring',
  components_notes_and_google_title_2: 'Daglig matlaging',
  components_notes_and_google_title_3: 'Konsekvente matlagingsferdigheter',
  components_review_google_text: 'Anmeldelser på Google',
  media_content_section_title: 'Matlagingsvideoer',
  media_content_section_subheader_text: 'Utforsk oppskrifter og trinnvise matlagingsvideoer.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Flere videoer',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Guider og artikler',
  text2_section_button_more: 'Flere artikler',
  components_text1_section_title: 'OPPSKRIFTER',
  components_text1_subheader_text: 'Deilige oppskrifter for daglig matlaging',
  components_text1_span_text: 'Oppdag lettfattelige oppskrifter designet for hverdagsmåltider, tydelige trinn og flotte resultater.',
  components_text1_card_1_title: 'Start dagen din riktig',
  components_text1_card_1_text: 'Enkle og smakfulle oppskrifter for å starte dagen med letthet og smak.',
  components_text1_card_3_title: 'Smakfulle lunsjideer',
  components_text1_card_3_text: 'Deilige lunsjoppskrifter som er enkle å lage og fulle av smak.',
  components_text1_card_2_title: 'Trøstende middagsoppskrifter',
  components_text1_card_2_text: 'Varme, mettende middagsoppskrifter, perfekte for avslappende kvelder hjemme.',
  components_text1_link: 'Se alle oppskrifter',
  components_footer_text: 'Lær bedre matlaging, lag bedre mat: Ditt kjøkken, din reise.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Juridisk',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Personvernerklæring',
  button_load_more: 'Last inn mer',
  page_media_1_content_hero_text: 'Oppdag enkle matlagingsvideoer for enhver smak',
  page_text1_hero_text: 'Oppskrifter',
  page_text1_section_title: 'Matlagingstips',
  page_text1_subheader_text: 'Oppskrifter',
  page_text2_hero_text: 'Bloggen vår',
  page_text2_section_title: 'Blogg',
  page_text2_subheader_text: 'Guider og artikler',
  enter_email_title: 'Vennligst skriv inn e-postadressen din for å fortsette',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Gå',
  components_login_success_text: 'Innlogging vellykket!',
  components_card_link_media_content: 'Se nå',
  components_card_link_text1_content: 'Se oppskrift',
  components_card_link_text2_content: 'Vis artikkel',
};